import React, { memo } from 'react';

import { QRCodeSVG } from 'qrcode.react';

type QRCodeProp = {
  url: string;
  size?: number;
  level?: string;
  includeMargin?: boolean;
};

const QRCode = memo(({ url, size, includeMargin, level, ...rest }: QRCodeProp) => {
  return (
    <QRCodeSVG
      value={window.location.origin + '/download?debankQRCode=' + url}
      size={size || 128}
      includeMargin={includeMargin}
      level={level}
    />
  );
});

export default QRCode;
